import gpmTechnologies from '@/assets/img/home/GPMTechnologies.png';
import mobileTechnologies from '@/assets/img/home/MobileTechnologies.png';
import mockup from '@/assets/img/home/Mockup.png';

/**
 * "Integrated Technologies within GPM" block — faithful port of the legacy
 * reipm `components/home/IntegratedTechnologies.tsx`. The technology-logo
 * strip swaps between a stacked mobile PNG and the wide desktop PNG at `lg`,
 * exactly like the legacy `block lg:hidden` / `hidden lg:block` pair.
 * (The legacy `md:pb-26` never resolved to a real Tailwind v3 utility, so the
 * rendered padding was `pb-10` — reproduced as such.)
 */
export const IntegratedTechnologies = () => {
  return (
    <div className="relative overflow-hidden bg-white py-12">
      <div className="flex w-full justify-center pb-10">
        <div className="mx-3 max-w-[1166px] flex-col items-center">
          <h2 className="mx-3 mb-6 text-center text-[24px] font-bold text-[#0061E5]">
            Integrated Technologies within GPM:
          </h2>

          <img
            src={mobileTechnologies}
            alt="Fulfilment Technologies"
            className="mx-auto block h-auto max-w-full lg:hidden"
            height={344}
            width={686}
          />
          <img
            src={gpmTechnologies}
            alt="Fulfilment Technologies"
            className="mx-auto hidden h-auto max-w-full lg:block"
            height={115}
            width={1996}
          />
          <div className="mt-10 flex w-full justify-center lg:mt-2">
            <img src={mockup} alt="Fulfilment Interfaces" className="h-auto max-w-full" height={527} width={1166} />
          </div>
        </div>
      </div>
    </div>
  );
};
